import { action, makeObservable } from 'mobx';
import { webServiceProvider } from '../shared';
import { AppStore } from 'stores';

const DIRECT_ENDPOINT = `${import.meta.env.VITE_API_URL}v1`;

class PurchaseOrderStore {
  constructor() {
    makeObservable(this, {
      fetchShopPurchaseOrders: action,
      savePurchaseOrder: action,
      deletePurchaseOrder: action,
    });
  }
  fetchShopPurchaseOrders = async (shopId, filters = {}) => {
    if (!shopId) {
      throw new Error('Invalid Id');
    }

    if (shopId === '-1' || shopId === -1) {
      return;
    }

    const abort = new AbortController();

    const query = new URLSearchParams();
    query.append('id_shop', shopId);
    if (filters.search) {
      query.append('search', filters.search);
    }
    if (filters.status) {
      query.append('status', filters.status);
    }

    const url = `${DIRECT_ENDPOINT}/purchase-order?${query.toString()}`;

    const response = await webServiceProvider.directFetchWithMethod(
      url,
      'GET',
      null,
      abort.signal
    );

    if (!response || !response.data) {
      AppStore.addError(
        'There was a problem fetching purchase orders. Please try reloading the page.'
      );
      return [];
    }
    const { data } = response;

    return data;
  };

  savePurchaseOrder = async ({ id, ...payload }) => {
    if (!payload) {
      throw new Error('Invalid Payload');
    }

    const abort = new AbortController();

    if (id) {
      const url = `${DIRECT_ENDPOINT}/purchase-order/${id}`;

      const data = await webServiceProvider.directFetchWithMethod(
        url,
        'PATCH',
        payload,
        abort.signal
      );

      return data;
    }

    const url = `${DIRECT_ENDPOINT}/purchase-order`;

    const data = await webServiceProvider.directFetchWithMethod(
      url,
      'POST',
      payload,
      abort.signal
    );

    return data;
  };

  deletePurchaseOrder = async (id) => {
    if (!id) {
      throw new Error('Invalid Id');
    }

    const abort = new AbortController();

    const url = `${DIRECT_ENDPOINT}/purchase-order/${id}`;

    await webServiceProvider.directFetchWithMethod(
      url,
      'DELETE',
      {
        id,
      },
      abort.signal
    );

    return;
  };

  getPurchaseOrderDetails = async (id) => {
    if (!id) {
      throw new Error('Invalid Id');
    }

    const abort = new AbortController();

    const url = `${DIRECT_ENDPOINT}/purchase-order/${id}`;

    const data = await webServiceProvider.directFetchWithMethod(
      url,
      'GET',
      null,
      abort.signal
    );

    return data;
  };
}

const purchaseOrderStore = new PurchaseOrderStore();
export default purchaseOrderStore;
